'use client'

import type { CreateSessionResponse } from '@/lib/compiler/types'
import { parseCreateSessionResponse } from '@/lib/compiler/guards'

export const AUTH_COMPILER_SESSION_KEY = 'rudrise-auth-compiler-session'

export function stashAuthCompilerSession(session: CreateSessionResponse | Record<string, unknown>): void {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.setItem(AUTH_COMPILER_SESSION_KEY, JSON.stringify(session))
  } catch {
    // ignore quota errors
  }
}

export function hasAuthCompilerSessionPending(): boolean {
  if (typeof window === 'undefined') return false
  return Boolean(sessionStorage.getItem(AUTH_COMPILER_SESSION_KEY))
}

export function consumeAuthCompilerSession(): CreateSessionResponse | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(AUTH_COMPILER_SESSION_KEY)
    if (!raw) return null
    sessionStorage.removeItem(AUTH_COMPILER_SESSION_KEY)

    const payload = JSON.parse(raw) as Record<string, unknown>
    const parsed = parseCreateSessionResponse(payload)
    if (!parsed) return null

    const mainFile =
      typeof payload.main_file === 'string'
        ? payload.main_file
        : typeof payload.mainFile === 'string'
          ? payload.mainFile
          : parsed.mainFile

    return {
      ...parsed,
      auto_compile: parsed.auto_compile ?? Boolean(payload.auto_compile),
      mainFile,
    }
  } catch {
    return null
  }
}
